<div class="outer">
  <form [formGroup]="form">
    <h1 *ngIf="!isAendern">{{ 'Position erfassen' | translate }}</h1>
    <h1 *ngIf="isAendern">{{ 'Position ändern' | translate }}</h1>

    <ion-item lines="none">
      <ion-label position="stacked">{{ 'Artikel' | translate }}</ion-label>

      <ion-input inputmode="numeric" type="text" min="0" step="1" pattern="\d+" formControlName="artikelNr" (keyup.enter)="app.closeKeyboard($event)" enterkeyhint="done" clearInput></ion-input>
    
      <!-- <ion-input type="text" formControlName="artikelNr" (keyup.enter)="app.closeKeyboard($event)" enterkeyhint="done" clearInput></ion-input> -->
      <ion-button class="datum-button" appClick (clicked)="onArtikelAendern()" size="default" color="light" slot="end">...</ion-button>

      <!-- <ion-select placeholder="{{ 'Bitte auswählen' | translate }}" interface="popover" formControlName="artikelNr" [okText]="'OK' | translate" [cancelText]="'Abbrechen' | translate" (ionChange)="onArtikelChanged()">
        <ion-select-option *ngFor="let p of artikelListe" [value]="p.Key">{{ p.bezeichnung }}</ion-select-option>
      </ion-select> -->
    </ion-item>

    <ion-item lines="none">
      <ion-label position="stacked">{{ 'MHD' | translate }}</ion-label>
      <ion-input type="text" formControlName="mhd" pattern="^\d{1,2}\.\d{1,2}\.\d{4}$" (keyup.enter)="app.closeKeyboard($event)" enterkeyhint="done" clearInput></ion-input>
      <ion-button class="datum-button" appClick (clicked)="selectDatum()" size="default" color="light" slot="end">...</ion-button>
    </ion-item>

    <ion-item lines="none">
      <ion-label position="stacked">{{ 'Menge' | translate }}</ion-label>
      <ion-input inputmode="numeric" type="text" min="0" step="1" pattern="\d+" formControlName="menge" (keyup.enter)="app.closeKeyboard($event)" enterkeyhint="done" clearInput></ion-input>
    </ion-item>

    <!-- <ion-item lines="none">
      <ion-label position="stacked">{{ 'GTIN' | translate }}</ion-label>
      <ion-input inputmode="text" type="text" formControlName="gtin" placeholder="" clearInput></ion-input>
    </ion-item> -->

    <!-- <ion-item lines="none">
      <ion-label position="stacked">{{ 'NVE' | translate }}</ion-label>
      <ion-input inputmode="text" type="text" formControlName="nve" placeholder="" clearInput></ion-input>
    </ion-item> -->

    <ion-item lines="none">
      <ion-label position="stacked">{{ 'Charge' | translate }}</ion-label>
      <ion-input inputmode="text" type="text" formControlName="charge" placeholder="Bitte eingeben" clearInput></ion-input>
    </ion-item>

    <div class="mt-15 buttons">
      <ion-button class="button-md" fill="solid" color="success" appClick (clicked)="onSpeichern()">OK</ion-button>
      <ion-button class="button-md" fill="solid" color="danger" appClick (clicked)="onLoeschen()" *ngIf="isAendern">Löschen</ion-button>
      <ion-button class="button-md" fill="solid" color="light" appClick (clicked)="onAbbrechen()">Abbr.</ion-button>
    </div>
  </form>
</div>